import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <section id="contact" className="contact">
      <h2>Contact</h2>
      <p>Email: singhkumarakshay22@gmail.com</p>
      <p>Phone: +91-7309507985</p>
      <p>Made with ❤️ by Akshay Kumar Singh</p>
    </section>
  );
}

export default Contact;
